export const allDateRanges = 'allDateRanges';
export const allStatuses = 'allStatuses';
